import React from 'react';
import Style from './header.module.scss';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/lib';
import { useActivation } from '../activation/ActivationContext';

const PromotionBar = (props) => {
  let navigator = useNavigate();
  const activationContext = useActivation();
  const activationData = activationContext?.activationData;

  let diff = null;
  if (activationData && typeof activationData.days_left === 'number') {
    diff = activationData.days_left;
  } else if (typeof props?.subscription?.data?.object?.days_left === 'number') {
    diff = props.subscription.data.object.days_left;
  } else if (!props?.subscription?.loading && props?.subscription?.data?.object?.current_period_end) {
    let current_period_end = DateTime.fromFormat(
      props?.subscription?.data?.object.current_period_end,
      'd MMM yyyy'
    );
    diff = Math.max(0, Math.ceil(
      current_period_end.diffNow('day').values.days
    ));
  }

  if (diff === null) {
    return null;
  }

  return (
    <div className={`${Style.info} ${Style.responsiveInfo}`}>
      {diff === 0 ? (
        <p>Your Trial has Ended.</p>
      ) : (
        <p>You have {diff} {diff === 1 ? 'day' : 'days'} left in your trial.</p>
      )}
      <Button
        variant="primary"
        text={diff === 0 ? "Subscribe to a Plan" : "Subscribe Now"}
        action={() => navigator('/account/billing?type=upgrade')}
        style={{ fontSize: 14, padding: "4px 7px", minWidth: "fit-content" }}
      />
    </div>
  );
};
export default PromotionBar;
